import React from 'react';

import { FormattedMessage } from 'react-intl';

import GlobeIcon from '@atlaskit/icon/core/globe';

import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo, RovoLogoFromLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { WebDomainSearchResultIcon } from './icon';
import { messages } from './messages';

export const atlassianWebCrawlerConfig: ThirdPartyConfig = {
	displayName: <FormattedMessage {...messages['atlassian-web-crawler']} />,
	id: 'atlassian-web-crawler',
	resourceType: ProductResourceTypes3P.AtlassianWebCrawler,
	icon: RovoLogoFromLogo(GlobeIcon, 'Atlassian Web Crawler'),
	searchResultIcon: get3PLogo(WebDomainSearchResultIcon, 'Atlassian Web Crawler', 'large'),
	integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WebPage,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: false,
	isEnabled: () => true,
	fanOutConnectorSources: true,
	displayWorkspaceNameAsProductName: true,
	getFiltersForSelectedDatasources: (datasource, existingFilters) => ({
		...existingFilters,
		additionalTexts: [
			...(existingFilters?.additionalTexts || []),
			...(datasource?.workspaceUrl ? [datasource.workspaceUrl] : []),
		],
	}),
};
